module.exports = __webpack_public_path__ + "img/index-section6-friend8.1b16c5f8.svg";